import { Box, Tooltip } from "@mui/material";
import { DiffResult, Differ, Viewer } from "json-diff-kit";
import { useMemo, useState } from "react";
import JsonTextArea from "./JsonTextArea";
import { firstSample, secondSample } from "../constants/SampleJson";

const d = new Differ({
  detectCircular: true,
  showModifications: true,
  arrayDiffMethod: "lcs",
  ignoreCase: false,
  recursiveEqual: true,
});

const CompareField = () => {
  const [firstJson, setFirstJson] = useState("");
  const [secondJson, setSecondJson] = useState("");

  const [firstJsonValid, setFirstJsonValid] = useState(false);
  const [secondJsonValid, setSecondJsonValid] = useState(false);

  const [parsedFirstJson, setParsedFirstJson] = useState({});
  const [parsedSecondJson, setParsedSecondJson] = useState({});

  const diff = useMemo(() => {
    if (firstJsonValid && secondJsonValid)
      return d.diff(parsedFirstJson, parsedSecondJson);
    return [[], []] as [DiffResult[], DiffResult[]];
  }, [firstJsonValid, secondJsonValid, parsedFirstJson, parsedSecondJson]);

  const equalityLabel = useMemo(() => {
    const isEqual = JSON.stringify(diff[0]) === JSON.stringify(diff[1]);
    if (isEqual)
      return (
        <>
          Both first and second JSON are{" "}
          <Tooltip title="Both JSON have the same content or meaning, regardless of differences in formatting or structure">
            <b className="tooltip-text" style={{ color: "#00b04f", cursor: "help" }}>
              semantically identical
            </b>
          </Tooltip>
        </>
      );
    return (
      <>
        Both first and second JSON are{" "}
        <b style={{ color: "#b12a0b" }}> not identical</b>
      </>
    );
  }, [diff]);

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', md: 'row' } }}>
          <Box sx={{ flex: 1 }}>
            <JsonTextArea
              label="First JSON"
              value={firstJson}
              setValue={setFirstJson}
              setJsonValid={setFirstJsonValid}
              setParsedJson={setParsedFirstJson}
              sampleValue={firstSample}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <JsonTextArea
              label="Second JSON"
              value={secondJson}
              setValue={setSecondJson}
              setJsonValid={setSecondJsonValid}
              setParsedJson={setParsedSecondJson}
              sampleValue={secondSample}
            />
          </Box>
        </Box>
      </Box>

      {firstJsonValid && secondJsonValid && (
        <>
          <hr style={{ marginTop: "1em", marginBottom: "1.5em" }} />
          <div style={{ marginBottom: "1em" }}>{equalityLabel}</div>
          <div
            style={{
              borderRadius: "4px",
              border: "1px rgba(0, 0, 0, 0.2) solid",
              background: "#fbfbfa",
              padding: "0.5em",
            }}
          >
            <Viewer diff={diff} indent={2} lineNumbers highlightInlineDiff />
          </div>
          <br />
          <br />
          <br />
          <br />
        </>
      )}
    </>
  );
};

export default CompareField;
